import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { acceptTerms } from '../services/api';

const AcceptTerms = () => {
  const [loading, setLoading] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const { user, updateUser } = useAuth();
  const navigate = useNavigate();

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (user.acceptedTerms) {
    return <Navigate to="/targets" />;
  }

  const handleAccept = async () => {
    if (!accepted) return;

    setLoading(true);
    try {
      const response = await acceptTerms();
      updateUser(response.data);
      navigate('/targets');
    } catch (error) {
      console.error('Error accepting terms:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="terms-container">
      <div className="terms-box">
        <h1>Termini e Condizioni</h1>
        <p className="terms-intro">
          Prima di utilizzare OldProject, ti chiediamo di leggere e accettare le seguenti informazioni sul trattamento dei dati.
        </p>

        <div className="terms-content">
          <h2>Informativa Privacy</h2>

          <h3>1. Titolare del trattamento</h3>
          <p>
            Il trattamento dei dati personali viene effettuato dall'amministratore della piattaforma OldProject per le finalita descritte di seguito.
          </p>

          <h3>2. Dati raccolti</h3>
          <p>La piattaforma raccoglie e gestisce i seguenti dati:</p>
          <ul>
            <li><strong>Dati di accesso:</strong> username e password (criptata)</li>
            <li><strong>Dati di attivita:</strong> proposte di visita create, partecipazioni, disponibilita indicate</li>
            <li><strong>Storico visite:</strong> date delle visite effettuate e persone visitate</li>
            <li><strong>Preferenze:</strong> lista di utenti autorizzati a visualizzare le proprie proposte</li>
          </ul>

          <h3>3. Finalita del trattamento</h3>
          <p>I dati sono utilizzati esclusivamente per:</p>
          <ul>
            <li>Consentire l'accesso alla piattaforma</li>
            <li>Coordinare le visite tra i membri del gruppo</li>
            <li>Mantenere uno storico delle visite effettuate</li>
            <li>Permettere la gestione delle preferenze di privacy</li>
          </ul>

          <h3>4. Conservazione dei dati</h3>
          <p>
            I dati sono conservati in un database locale e non vengono condivisi con terze parti.
            I dati verranno conservati per il tempo necessario alle finalita sopra descritte.
          </p>

          <h3>5. Diritti dell'utente</h3>
          <p>
            Puoi richiedere in qualsiasi momento all'amministratore la modifica o la cancellazione dei tuoi dati personali.
          </p>

          <h3>6. Sicurezza</h3>
          <p>
            Le password sono memorizzate in forma criptata. L'accesso ai dati e protetto da autenticazione.
          </p>
        </div>

        <div className="terms-accept">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={accepted}
              onChange={(e) => setAccepted(e.target.checked)}
            />
            <span>Ho letto e accetto i termini e condizioni e l'informativa privacy</span>
          </label>

          <button
            onClick={handleAccept}
            className="btn btn-primary"
            disabled={!accepted || loading}
          >
            {loading ? 'Caricamento...' : 'Accetta e continua'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AcceptTerms;
